var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import UnauthorizedAccess from '@patternfly/react-component-groups/dist/dynamic/UnauthorizedAccess';
var NotAuthorized = function (_a) {
    var _b = _a.bodyText, bodyText = _b === void 0 ? (_jsxs(_Fragment, { children: ["Contact your organization administrator(s) for more information or visit\u00A0", _jsx("a", { href: "./iam/my-user-access", children: "My User Access" }), "\u00A0to learn more about your permissions."] })) : _b, props = __rest(_a, ["bodyText"]);
    return _jsx(UnauthorizedAccess, __assign({}, props, { bodyText: bodyText }));
};
export default NotAuthorized;
//# sourceMappingURL=NotAuthorized.js.map